/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Embeddings_BalanceInputs */

const es_admin_company_overview_embeddings_balance = /** @type {(inputs: Admin_Company_Overview_Embeddings_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad de procesamiento`)
};

const en_admin_company_overview_embeddings_balance = /** @type {(inputs: Admin_Company_Overview_Embeddings_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embeddings balance`)
};

/**
* | output |
* | --- |
* | "Embeddings balance" |
*
* @param {Admin_Company_Overview_Embeddings_BalanceInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_embeddings_balance = /** @type {((inputs?: Admin_Company_Overview_Embeddings_BalanceInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Embeddings_BalanceInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_embeddings_balance(inputs)
	return en_admin_company_overview_embeddings_balance(inputs)
});
export { admin_company_overview_embeddings_balance as "admin.company_overview.embeddings_balance" }